import { React } from 'react'
import '../../styles/components/hero-items/game-main.scss'

const PhantomMain = () => (
    <>
        <div style={{ marginTop: '50px' }}>
            <div className='game-banner phantom-hero'>
                <div className='game-logo'>
                    <img className='pb-logo' src='./img/logos/PB_logo_Remastered_small.png' alt='Phantom Brave Logo' />
                </div>
            </div>{' '}
        </div>
    </>
)

export default PhantomMain
